import React from 'react'

import Select from 'react-select'

import styles from '../styles.module.scss'
import { vehicleTheme, getVehicleStyle } from "../../../helper/style";
import IOption from '../../../interfaces/IOption';

interface ISingleSelect {
  title?: string,
  value: IOption | null,
  options: IOption[],
  screen1440?: boolean,
  onChange: (value: IOption | null) => void,
  placeholder: string,
  onClick?: () => void
}

export default function SingleSelect({title, value, options, screen1440, onChange, placeholder, onClick}: ISingleSelect) {
  return (
    <div className={styles.selector}>
      { !!title && <p>{ title }</p> }
      
      <div className={styles.selectorHolder} onClick={onClick}>
        <Select
          id={title}
          placeholder={placeholder}
          value={value}
          options={options}
          onChange={onChange}
          styles={getVehicleStyle(false, screen1440)}
          theme={vehicleTheme}
        />  
      </div>
    </div>
  )
}